module.exports = __webpack_public_path__ + "static/media/CorrectorRegister_bg.b53e1eca.jpg";